import { ethers } from 'ethers'

export async function connectWallet(store) {
  if (!window.ethereum) { alert('MetaMask not found'); return }

  const provider = new ethers.providers.Web3Provider(window.ethereum)
  await provider.send('eth_requestAccounts', [])
  const signer = provider.getSigner()
  const address = await signer.getAddress()
  const network = await provider.getNetwork()

  store.commit('SET_WALLET', { address, chainId: network.chainId })
  localStorage.setItem('walletConnected', '1')
}
